export const mutations = {
  setInformationIndex: (state, payload) => {
      state.informationIndex = payload.informationIndex
  },
  setAreaId: (state, payload) => {
      state.areaId = payload.areaId
  },
  setNavName: (state, payload) => {
      state.navName = payload.navName
  },
}


// WEBPACK FOOTER //
// ./src/store/mutations.js